import { connect } from 'react-redux';
import { compose } from 'redux';
import { Card } from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import PropertyRadio from './components/PropertyRadio';
import PropertyDropdown from './components/PropertyDropdown';
import BaseFeature from './BaseFeature';
import { getHours } from '../../../../../../utils/constantValues';
import { DALI_DEXAL_SETTINGS, DALI_DT8_TW_SETTINGS } from '../../../../../../utils/constantFeatures';
import { linearPercentage, logarithmicPercentage } from '../../../../../../utils/percentageUtility';
import Checkbox from 'components/shared/StandaloneCheckbox';
import { Trans, withTranslation } from 'react-i18next';

class DaliSetting extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[DALI_DEXAL_SETTINGS.dimmingCurve].value === "1" ? true : false,
            isCheckedPowerON: !this.isOn(this.props.properties[DALI_DEXAL_SETTINGS.powerOnLevel]),
            isCheckedPowerONColour: !this.isOn(this.props.extraProperties[DALI_DT8_TW_SETTINGS.powerOnColourTemperature]),
            isCheckedSystemFailure: !this.isOn(this.props.properties[DALI_DEXAL_SETTINGS.systemFailureLevel]),
            isCheckedSystemFailureColour: !this.isOn(this.props.extraProperties[DALI_DT8_TW_SETTINGS.systemFailureColourTemperature]),
            //isCheckedExtendedFadeTime: this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime].value !== "0" ? true : false
            isCheckedExtendedFadeTime: !this.isOnExtendedFadeTime(this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime]) ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCheckboxes = this.handleChangeCheckboxes.bind(this);
    }

    isOn(property) {
        return property != null && property.value !== 'Off' && property.value !== property.valueMeta.off;
    }

    isOnExtendedFadeTime(property) {
        return property != null && property.value !== 'Off' && property.value !== property.valueMeta.off && property.value === "0";
    }

    handleChange(propertyName, value) {
        const v = value;

        if (this.getCorrectPropertyName(propertyName) === DALI_DEXAL_SETTINGS.dimmingCurve) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }

        if ((this.getCorrectPropertyName(propertyName) === DALI_DT8_TW_SETTINGS.powerOnColourTemperature) || (this.getCorrectPropertyName(propertyName) === DALI_DT8_TW_SETTINGS.systemFailureColourTemperature)) {
            let property = this.props.extraProperties[propertyName];
            property.value = value;
            this.props.handleChangeExtraProperties(property);
        }
        else {
            this.props.handleChange(propertyName, v);
        }
    }

    getPercentage(value, min, max) {
        if (value === 'Off') {
            return null;
        }

        if (this.props.properties[DALI_DEXAL_SETTINGS.dimmingCurve].value === '1') {
            return linearPercentage(value, min, max);
        }
        return logarithmicPercentage(value, min, max);
    }

    handleChangeCheckboxes(e) {
        const checked = e.target.checked;
        switch (e.target.name) {
            case "poweron":
                this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.powerOnLevel].info.name, checked ? "Off" : "254");
                this.setState({ isCheckedPowerON: checked });
                break;
            case "systemfailure":
                this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.systemFailureLevel].info.name, checked ? "Off" : "254");
                this.setState({ isCheckedSystemFailure: checked });
                break;
            case "poweroncolour":
                let powerOnColourTemperature = this.props.extraProperties[DALI_DT8_TW_SETTINGS.powerOnColourTemperature];
                powerOnColourTemperature.value = checked ? "Off" : "4000";
                this.props.handleChangeExtraProperties(powerOnColourTemperature);
                this.setState({ isCheckedPowerONColour: checked });
                break;
            case "systemfailurecolour":
                let systemFailureColourTemperature = this.props.extraProperties[DALI_DT8_TW_SETTINGS.systemFailureColourTemperature];
                systemFailureColourTemperature.value = checked ? "Off" : "4000";
                this.props.handleChangeExtraProperties(systemFailureColourTemperature);
                this.setState({ isCheckedSystemFailureColour: checked });
                break;
            case "extendedfadetime":
                //checked true --> da.ft = 0
                //checked false --> da.et = 0

                if(checked) {
                    this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.fadeTime].info.name, "0");
                    this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime].info.name, "1");
                }
                else {
                    this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.fadeTime].info.name, "1");
                    this.props.handleChange(this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime].info.name, "0");
                }

                this.setState({ isCheckedExtendedFadeTime: checked });
                break;
            default:
                break;
        }
    }

    renderExtendedFadeTimeDiv() {
        const { t } = this.props;
        if (this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime]) {
            return (
                <div>
                    <Checkbox
                        name={"extendedfadetime"}
                        checked={this.state.isCheckedExtendedFadeTime}
                        style={{ margin: "auto 0.5rem" }}
                        onChange={this.handleChangeCheckboxes}
                    />
                    {t('Extended_Fade_Time')}
                </div>);
        }
        else {
            return null;
        }
    }

    getFadeRateCard(daFft, fadeTime, fadeRate) {
        const { t } = this.props;

        if (fadeTime && fadeRate) {

            const fadeTimeDropdown = daFft && this.state.isCheckedExtendedFadeTime ? daFft : fadeTime;

            return (
                <Card className={this.getClassName([fadeTime, fadeRate])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="Fade" />}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        {this.renderExtendedFadeTimeDiv()}
                        <PropertyDropdown
                            property={fadeTimeDropdown}
                            properties={fadeTimeDropdown.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            propertyDisplayFunc={getHours}
                            title={t('Fade_Time')}
                            measureUnit={'mm:ss'}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyDropdown
                            property={fadeRate}
                            properties={fadeRate.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            type={'faderate'}
                            title={t('Fade_Rate')}
                            measureUnit={'steps/s'}
                            handleChange={this.handleChange} />
                        {/* <PropertyDropdown
                            property={daFft}
                            properties={daFft.valueMeta.availableValues.sort((a, b) => parseFloat(a) - parseFloat(b))}
                            title={'Extended Fade Time'}
                            measureUnit={'s'}
                            handleChange={this.handleChange} /> */}
                    </Card.Body>
                </Card>
            );
        }

        return null;
    }

    getPowerOnDelayCard(daPod) {
        const { t } = this.props;

        if (daPod) {
            const powerOnDelayDropdown = daPod;

            return (
                <Card className={this.getClassName([daPod])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="Power_On_Delay" />}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', paddingRight: '2.5rem' }}>
                        <PropertyDropdown
                            property={powerOnDelayDropdown}
                            properties={powerOnDelayDropdown.valueMeta.availableValues}
                            type={'powerondelay'}
                            title={t('power_on_delay_value')}
                            measureUnit={''}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            );
        }

        return null;
    }

    getPowerCard(daMin, daMax, daPon, daSys) {

        const powerOnColourTemperature = this.props.extraProperties[DALI_DT8_TW_SETTINGS.powerOnColourTemperature];
        const systemFailureColourTemperature = this.props.extraProperties[DALI_DT8_TW_SETTINGS.systemFailureColourTemperature];

        const displayColors = this.props.driverFeatures.some(item => item.name === 'd8');

        if (daMin && daMax && daPon && daSys) {
            return (
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([daPon])}>
                        <div className="card-header-feature">
                            {daPon.info.displayName.replace(/([A-Z])/g, ' $1')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyPicker
                                disabled={this.state.isCheckedPowerON}
                                property={daPon}
                                title={<Trans i18nKey="Level" />}
                                measureUnit={this.getPercentage(daPon.value, 1, 254)}
                                min={daMin ? Math.max(daMin.value, daPon.valueMeta.min) : daPon.valueMeta.min}
                                max={daMax ? Math.min(daMax.value, daPon.valueMeta.max) : daPon.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <div>
                                <Checkbox
                                    name={"poweron"}
                                    checked={this.state.isCheckedPowerON}
                                    style={{ margin: "auto 0.5rem" }}
                                    onChange={this.handleChangeCheckboxes}
                                />
                                {<Trans i18nKey="Use_last_stored_level_on_Power_ON" />}
                            </div>

                            {/* {powerOnColourTemperature && this.props.isTW && this.props.opModeName != 'td_d2w' && this.props.opModeName != 'td_tw' ? */}
                            {displayColors ?
                                <div>
                                    <PropertyPicker
                                        disabled={this.state.isCheckedPowerONColour}
                                        property={powerOnColourTemperature}
                                        title={<Trans i18nKey="Colour_Temperature" />}
                                        type={"Mirek"}
                                        measureUnit={powerOnColourTemperature.info.unit}
                                        min={powerOnColourTemperature.valueMeta.min}
                                        max={powerOnColourTemperature.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                    <div>
                                        <Checkbox
                                            name={"poweroncolour"}
                                            checked={this.state.isCheckedPowerONColour}
                                            style={{ margin: "auto 0.5rem" }}
                                            onChange={this.handleChangeCheckboxes}
                                        />
                                        <Trans i18nKey="Use_last_stored_colour_temperature_on_Power_ON" />
                                    </div>
                                </div>
                                :
                                null
                            }
                        </Card.Body>
                    </Card>
                    <Card className={this.getClassName([daSys])}>
                        <div className="card-header-feature">
                            {daSys.info.displayName.replace(/([A-Z])/g, ' $1')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyPicker
                                disabled={this.state.isCheckedSystemFailure}
                                property={daSys}
                                title={<Trans i18nKey="Level" />}
                                measureUnit={this.getPercentage(daSys.value, 1, 254)}
                                min={daMin.value}
                                max={daMax.value}
                                step={1}
                                handleChange={this.handleChange} />
                            <div>
                                <Checkbox
                                    name={"systemfailure"}
                                    checked={this.state.isCheckedSystemFailure}
                                    style={{ margin: "auto 0.5rem" }}
                                    onChange={this.handleChangeCheckboxes}
                                />
                                {<Trans i18nKey="Dont_change_existing_level_on_System_Failure" />}
                            </div>

                            {/* {systemFailureColourTemperature && this.props.isTW && this.props.opModeName != 'td_d2w' && this.props.opModeName != 'td_tw' ? */}
                            {displayColors ?
                                <div>
                                    <PropertyPicker
                                        disabled={this.state.isCheckedSystemFailureColour}
                                        property={systemFailureColourTemperature}
                                        title={<Trans i18nKey="Colour_Temperature" />}
                                        type={"Mirek"}
                                        measureUnit={systemFailureColourTemperature.info.unit}
                                        min={systemFailureColourTemperature.valueMeta.min}
                                        max={systemFailureColourTemperature.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                    <div>
                                        <Checkbox
                                            name={"systemfailurecolour"}
                                            checked={this.state.isCheckedSystemFailureColour}
                                            style={{ margin: "auto 0.5rem" }}
                                            onChange={this.handleChangeCheckboxes}
                                        />
                                        <Trans i18nKey="Dont_change_colour_on_System_Failure" />
                                    </div>
                                </div>
                                :
                                null
                            }
                        </Card.Body>
                    </Card>
                </div>
            );
        }

        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.properties !== prevProps.properties) {
            this.setState({ isCheckedPowerON: !this.isOn(this.props.properties[DALI_DEXAL_SETTINGS.powerOnLevel]) });
            this.setState({ isCheckedSystemFailure: !this.isOn(this.props.properties[DALI_DEXAL_SETTINGS.systemFailureLevel]) });
            this.setState({ isCheckedPowerONColour: !this.isOn(this.props.extraProperties[DALI_DT8_TW_SETTINGS.powerOnColourTemperature]) });
            this.setState({ isCheckedSystemFailureColour: !this.isOn(this.props.extraProperties[DALI_DT8_TW_SETTINGS.systemFailureColourTemperature]) });
            this.setState({ isCheckedExtendedFadeTime: !this.isOnExtendedFadeTime(this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime]) ? true : false });
        }
    }

    render() {

        const daDic = this.props.properties[DALI_DEXAL_SETTINGS.dimmingCurve];
        const daFft = this.props.properties[DALI_DEXAL_SETTINGS.extendedFadeTime];
        const fadeTime = this.props.properties[DALI_DEXAL_SETTINGS.fadeTime];
        const fadeRate = this.props.properties[DALI_DEXAL_SETTINGS.fadeRate];
        const daMax = this.props.properties[DALI_DEXAL_SETTINGS.maximum];
        const daMin = this.props.properties[DALI_DEXAL_SETTINGS.minimum];
        const daPon = this.props.properties[DALI_DEXAL_SETTINGS.powerOnLevel];
        const daSys = this.props.properties[DALI_DEXAL_SETTINGS.systemFailureLevel];
        const daPod = this.props.properties[DALI_DEXAL_SETTINGS.powerOnDelay];

        return (
            <div>
                <div className="flex-row">
                    <Card className={this.getClassName([daDic])}>
                        <div className="card-header-feature">
                            {daDic.info.displayName.replace(/([A-Z])/g, ' $1')}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem', minWidth: '160px' }}>
                            <PropertyRadio
                                property={daDic}
                                valueForTrue={"1"}
                                //isChecked={this.state.isEnabled}
                                isChecked={daDic.value === "1"}
                                title={<Trans i18nKey="Linear" />}
                                handleChange={this.handleChange} />
                            <PropertyRadio
                                property={daDic}
                                valueForTrue={["0", "Off"]}
                                //isChecked={!this.state.isEnabled}
                                isChecked={(daDic.value === "0") || (daDic.value === "Off")}
                                title={<Trans i18nKey="Logarithmic" />}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>

                    {this.getFadeRateCard(daFft, fadeTime, fadeRate)}

                    <Card className={this.getClassName([daMin, daMax])}>
                        <div className="card-header-feature">
                            {<Trans i18nKey="Limits" />}
                        </div>
                        <Card.Body className="card-body-feature" style={{ minWidth: '250px' }}>
                            <PropertyPicker
                                property={daMin}
                                title={<Trans i18nKey="Min_Level" />}
                                measureUnit={this.getPercentage(daMin.value, 1, 254)}
                                min={daMin.valueMeta.min}
                                max={daMax ? Math.min(daMax.value, daMin.valueMeta.max) : daMin.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            {
                                daMax ?
                                    <PropertyPicker
                                        property={daMax}
                                        title={<Trans i18nKey="Max_Level" />}
                                        measureUnit={this.getPercentage(daMax.value, 1, 254)}
                                        min={daMin.value ? Math.max(daMin.value, daMax.valueMeta.min) : daMax.valueMeta.min}
                                        max={daMax.valueMeta.max}
                                        step={1}
                                        handleChange={this.handleChange} />
                                    : null
                            }

                        </Card.Body>
                    </Card>
                </div>

                {this.getPowerCard(daMin, daMax, daPon, daSys)}
                { this.getPowerOnDelayCard(daPod)}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps),
    withTranslation()
)(DaliSetting);
